module.exports = __webpack_public_path__ + "img/no-people.2e966b41.png";